import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { SiteService } from "../../services/site.service";
import { FilterCriteria } from "../../types/FilterCriteria";
import {
  DxAccordionModule, DxCheckBoxModule, DxSliderModule, DxTagBoxModule, DxTemplateModule
} from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { Router } from "@angular/router";
import { SiteList } from '../../types/Site';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { SharedService } from "../../../services/SharedService";
import { Utility } from "../../../common/service/utility";
import { Coordinates } from "../../types/Location";
import { StateService } from "src/app/common/state_services/state.service";

@Component({
  selector: 'app-sitelist',
  templateUrl: './sitelist.component.html',
  styleUrls: ['./sitelist.component.scss']
})
export class SiteListComponent implements OnInit {

  SiteListForm: FormGroup;
  siteListData: SiteList[];
  dataSource: any;
  searchModeOption = 'contains';
  searchExprOption: any = 'Name';
  searchTimeoutOption = 200;
  minSearchLengthOption = 0;
  showDataBeforeSearchOption = false;
  isAnySiteSelected: boolean = false;
  isAnyFacilitySelected: boolean = false;
  readonly allowedPageSizes = [10, 20, 50, 100, 200];
  filtercriteriaobj: FilterCriteria;
  paramFilter = {};
  productActivitiesData: DataSource;
  specificProcessData: DataSource;
  data: any;
  dataAccordion: any[];
  isLoadPanelVisible = true;
  siteSelectedItemKeys: any[] = [];
  rowData: any;
  visibleCol = false;
  editPopupTitle: string;
  filterValue: Array<any>;
  countiesDataSource: DataSource<any, any>;
  defaultCountryId: string = "US";
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  Coordinates: Coordinates = new Coordinates();
  mapsPopupVisible: boolean;
  isMapViewAvailable: boolean;
  maxRetries = 2;
  retryCount = 0;

  constructor(private siteSvc: SiteService,
    private router: Router,
    private utility: Utility,
    private notificationService: NotificationService,
    public sharedSvc: SharedService,
    public stateSvc: StateService) {
    this.sharedSvc.previousRouteToEditFacility = "plants";
    this.dataAccordion = [{
      ID: 1,
      header: "FilterBy"
    }]
  }

  ngOnInit(): void {
    this.getAllProductActivities();
    this.getAllSpecificProcess();
    this.getAllCountries();
    if (this.stateSvc.siteListFilters) {
      this.filtercriteriaobj = this.stateSvc.siteListFilters;
    }
    else {
      this.filtercriteriaobj = new FilterCriteria(false, false, false, false, false, false, false, false, false, false, this.defaultCountryId);
    }
    this.getPlants();
    this.filterValue = [
      ['countryName', '=', 'USA']
    ]
  }

  getAllCountries() {
    this.siteSvc.GetAllCountries().subscribe({
      next: data => {
        data = data.filter(x => x.countryName != "Not assigned");
        this.countiesDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'countryName',
          },
        });
      }, error: error => {
        this.notificationService.alert("error", "Error while fetching all countries", error);
        this.isLoadPanelVisible = false;
      }
    })
  }

  getPlants() {
    this.isLoadPanelVisible = true;
    this.stateSvc.siteListFilters = this.filtercriteriaobj;
    this.siteSvc.getAllSites(this.filtercriteriaobj).subscribe({
      next: compressedData => {
        var decompressedData = this.utility.decompressData(compressedData);
        var plantdata: SiteList[] = JSON.parse(decompressedData);
        this.siteListData = plantdata;
        this.dataSource = plantdata;
        this.resetFilters();
        this.onFilterSelected();
        this.isLoadPanelVisible = false;
      },
      error: error => {
        if (error.status == 504) {
          if (this.retryCount < this.maxRetries) { // attempt a retry if max retries not reached
            this.retryCount++;
            this.getPlants()
            return;
          }
        }

        this.notificationService.alert("error", "Error while fetching site list", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  onFilterSelected() {
    let fileteredData: SiteList[] = [];
    if (this.dataSource.length > 0) {
      if (this.filtercriteriaobj.specificProcess.length > 0 || this.filtercriteriaobj.prodActivity.length > 0) {
        if (this.filtercriteriaobj.specificProcess.length > 0) {
          this.filtercriteriaobj.specificProcess.forEach(element => {
            fileteredData.push(...this.siteListData.filter(x => x.activityProcessFeedstockIndustry && x.activityProcessFeedstockIndustry.indexOf(element) > -1));
          });
        }
        if (this.filtercriteriaobj.prodActivity.length > 0) {
          this.filtercriteriaobj.prodActivity.forEach(element => {
            fileteredData.push(...this.siteListData.filter(x => x.activityProcessFeedstockIndustry && x.activityProcessFeedstockIndustry.indexOf(element) > -1));
          });
        }
        this.dataSource = fileteredData;
      }
      else {
        this.dataSource = this.siteListData;
      }
      if (this.filtercriteriaobj.isHyco) {
        this.dataSource = this.dataSource.filter(x => x.facilityType == "HYCO");
      }
      if (this.filtercriteriaobj.isAsu) {
        this.dataSource = this.dataSource.filter(x => x.facilityType == "LASU");
      }
      if (this.filtercriteriaobj.isGeneral) {
        this.dataSource = this.dataSource.filter(x => x.facilityType == "General");
      }
    }
  }

  getAllProductActivities() {
    this.siteSvc.getAllProductAcitivities().subscribe({
      next: data => {
        this.productActivitiesData = new DataSource({
          store: new ArrayStore({
            data: data.filter(x => x.productionActivityName !== null),
            key: 'productionActivityName',
          }),
        });
      },
      error: error => {
        this.notificationService.alert("error", "Error while fetching all Production Activities.", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  siteSelectionChanged(data: any) {
    this.rowData = data;
    this.siteSelectedItemKeys = data.selectedRowKeys;
    if (this.siteSelectedItemKeys.length > 0) {
      this.isAnySiteSelected = true;
    } else {
      this.isAnySiteSelected = false;
    }

    if (this.rowData.selectedRowsData[0].productionFacilityId !== null) {
      this.isAnyFacilitySelected = true;
    } else {
      this.isAnyFacilitySelected = false;
    }

    let obj = this.siteListData.filter(x => x.siteId == this.rowData.selectedRowsData[0].siteId)[0];
    if (obj.latitude && obj.longitude) {
      this.isMapViewAvailable = true;
      this.Coordinates.latitude = obj.latitude;
      this.Coordinates.longitude = obj.longitude;
    }
    else {
      this.isMapViewAvailable = false;
    }

  }

  addNewFacility() {
    this.router.navigate([`/sitesummary/${this.rowData.selectedRowsData[0].siteId}`]);
  }

  editFacility() {
    this.sharedSvc.previousRouteToEditFacility = "plants";
    this.router.navigate([`/facility/${this.rowData.selectedRowsData[0].siteId}/${this.rowData.selectedRowsData[0].productionFacilityId}`]);
  }

  getAllSpecificProcess() {
    this.siteSvc.getAllSpecificProcess().subscribe({
      next: data => {
        this.specificProcessData = new DataSource({
          store: new ArrayStore({
            data: data,
            key: 'specificProcessName',
          }),
        });
      },
      error: error => {
        this.notificationService.alert("error", "Error while fetching all specific processes.", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  ClearFilters() {
    this.filtercriteriaobj = new FilterCriteria(false, false, false, false, false, false, false, false, false, false, this.defaultCountryId);
  }

  exportExcel(e) {
    this.isLoadPanelVisible = true;
    this.dataGrid.instance.columnOption('latitude', 'visible', true);
    this.dataGrid.instance.columnOption('longitude', 'visible', true);
    this.dataGrid.instance.columnOption('modifiedBy', 'visible', true);
    this.dataGrid.instance.columnOption('modifiedDate', 'visible', true);
    this.dataGrid.instance.columnOption('insertedBy', 'visible', true);
    this.dataGrid.instance.columnOption('insertedDate', 'visible', true);
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Sitelist.xlsx');
        });
    }).then(() => {
      this.dataGrid.instance.columnOption('latitude', 'visible', false);
      this.dataGrid.instance.columnOption('longitude', 'visible', false);
      this.dataGrid.instance.columnOption('modifiedBy', 'visible', false);
      this.dataGrid.instance.columnOption('modifiedDate', 'visible', false);
      this.dataGrid.instance.columnOption('insertedBy', 'visible', false);
      this.dataGrid.instance.columnOption('insertedDate', 'visible', false);
      this.isLoadPanelVisible = false;
    });

    e.cancel = true;
  }

  resetFilters() {
    this.dataGrid.instance.clearFilter();
  }

  redirectToEditPage() {
    let id = this.rowData.selectedRowsData[0].siteId;
    if (this.rowData.selectedRowsData[0].productionFacilityId != null) {
      this.sharedSvc.isFacilityLinked = true;
    }
    else {
      this.sharedSvc.isFacilityLinked = false;
    }
    this.sharedSvc.previousRouteToEditSite = "plants";
    this.router.navigate([`/editsite/${id}`]);
  }

  redirectToAddNew() {
    this.sharedSvc.previousRouteToEditSite = "plants";
    this.router.navigate([`/editsite/`]);
  }

  mapview() {
    this.mapsPopupVisible = true;
  }

  setmapsPopupVisibility(isVisible) {
    let obj = this.siteListData.filter(x => x.siteId == this.rowData.selectedRowsData[0].siteId)[0];
    if (obj) {
      this.isMapViewAvailable = true;
      this.Coordinates.latitude = obj.latitude;
      this.Coordinates.longitude = obj.longitude;
      this.mapsPopupVisible = isVisible;
    }
    else {
      this.isMapViewAvailable = false;
    }
  }
}
